﻿import { IUnitsConverter, UnitsConversionModes, UnitsConversionPreferenceLocalStorageKey, getModeFromString } from "./Converters/UnitsConverter/IUnitsConverter";
import { DefaultUnitsConverter } from "./Converters/UnitsConverter/DefaultUnitsConverter";
import { LoginPage } from "./Login/LoginPage";
import { StaticDataManager } from "./StaticDataManager";
import { HashDataManager } from "./HashDataManager";
import { IPage } from "./IPage";
import { MapPage } from "./Pages/Map/MapPage";
import { GOMAveragesManager } from "./GOMAveragesManager";
import { IHashData } from "./IHashData";
import { WarningGroup } from "./Model/WarningGroup";
import { NavBar } from "./NavBar";
import { SimpleDialog } from "./SimpleDialog";
import { IRegion, IRegionalAdministratorsResponse, IStationsByRegion } from "./Model/Region";
import { RESTError } from "./API/RESTError";
import { getRegionalAdministrators } from "./API/Users/Users";
import { getCurrentUser, login } from "./API/Session/Session";
import { UserAccount } from "./Model/UserAccount";
import { GetPermissionGroupsForUser, GroupPermission } from "./API/GroupPermissions/GroupPermissions";
import { Station } from "./Model/Station";
import { WarningRuleSet } from "./Model/WarningRuleSet";
import { ParameterInfo, ParameterSchemaSensor } from "./API/Schema/ParameterSchema";
import { LiveDataSetStation, LiveDataSetValue } from "./API/LiveData/LiveDataSet";
import { ForecastsPDFs } from "./Pages/ForecastsPDFs/ForecastsPDFsPage";
import { GOMTablePage } from "./Pages/GOMTable/GOMTablePage";
import { ManagePermissionGroupsPage } from "./Pages/GroupPermissions/ManagePermissionGroupsPage";
import { PlottingPage } from "./Pages/Plotting/PlottingPage";
import { SiteObservations } from "./Pages/SiteObservations/SiteObservations";
import { EmailUsersPage } from "./Pages/EmailUsersPage";
import { ManageAlertsPage } from "./Pages/ManageAlertsPage";
import { ManageParameterGroupSettingsPage } from "./Pages/ManageParameterGroupsSettings";
import { ManageUsersPage } from "./Pages/ManageUsersPage";
import { PasswordResetPage } from "./Pages/PasswordResetPage";
import { SupportPage } from "./Pages/SupportPage";
import { TablePage } from "./Pages/Table/TablePage";
import { AutoNotificationsPage } from "./Pages/AutoNotifications/AutoNotificationsPage";
import { AutoNotificationThresholdsPage } from "./Pages/AutoNotifications/AutoNotificationThresholdsPage";
import { LiveDataManager } from "./LiveDataManager";

export enum DisplayTimeType {
    UTC = 'UTC',
    PcTime = 'Pc Time',
    StationRegionTime = 'Station/Region Time',
    StationTime = 'Station Time'
}

export interface ITimeZoneData {
    timeZoneName: string;
    timeZoneCode: string;
    offsetMinutes: number;
    offsetString: string;
    label: string;
    displayTimeType: string;
}

var _unitConverter: IUnitsConverter;

export class MainSite {
    public static instance: MainSite;

    public static run() {
        MainSite.instance = new MainSite();
        $(() => {
            MainSite.instance.currentLoginPage = new LoginPage();
            MainSite.instance.currentLoginPage.render();
            MainSite.instance.tryLogin();
        });
    }

    public static getUnitConverter(): IUnitsConverter {
        if (!_unitConverter) {
            let ucOptKey = UnitsConversionPreferenceLocalStorageKey;
            let ucOptVal = MainSite.localStorageGet(ucOptKey, undefined); //: uses the first enum option as a default.

            _unitConverter = new DefaultUnitsConverter(getModeFromString(ucOptVal));
        }

        return _unitConverter;
    };

    public staticDataManager: StaticDataManager = new StaticDataManager();
    public hashDataManager: HashDataManager = new HashDataManager();

    private modal: JQuery = null;
    public displayTimeType: DisplayTimeType = null;
    public basicViewSelectorBool: boolean = null;
    public selectedWarningRules: WarningGroup = null;
    public selectedRegion: IRegion = null;

    private pages: IPage[] = [
        new MapPage(this),
        new TablePage(this),
        new GOMTablePage(this),
        //...(((this.selectedRegion) && (this.selectedRegion.Id == "GOM"))
        //    ? [new GOMTablePage(this)]
        //    : [new TablePage(this)]),
        //...(this.selectedRegion?.Id !== "GOM"
        //    ? [new TablePage(this)]
        //    : []),
        //...(true
        //    ? [new GOMTablePage(this)]
        //    : []),
        new PlottingPage(this),
        new SiteObservations(this),
        new PasswordResetPage(this),
        new ManageUsersPage(this),
        new ManagePermissionGroupsPage(this),
        new EmailUsersPage(this),
        new AutoNotificationsPage(this),
        new SupportPage(this),
        new ManageAlertsPage(this),
        new ManageParameterGroupSettingsPage(this),
        new AutoNotificationThresholdsPage(this),
        new ForecastsPDFs(this),
        //new DigitalWeatherPage(this)
    ];

    public navBar: NavBar = new NavBar();

    constructor() {
        this.pages.forEach((page: IPage) => {
            page.initialize();
        });
    }

    //regionalAdminPopover = $('<strong data-toggle="popover" role="button" data-placement="bottom" title="Regional Administrators" data-content="North Sea Administrator">Regional Administrator</strong>').popover({ html: true });

    private _regionalAdministrators: IRegionalAdministratorsResponse = null;
    private retrieveRegionalAdministrators(callback: (err: RESTError, data?: IRegionalAdministratorsResponse) => any): void {
        if (this._regionalAdministrators == null) {
            getRegionalAdministrators((err, data) => {
                if (!err && data) {
                    this._regionalAdministrators = data;
                }

                callback(err, data);
            });
        } else {
            callback(null, this._regionalAdministrators);
        }
    }

    public setupRegionalAdminPopover(link: JQuery): JQuery {
        var showCount = 0;

        link.popover({
            html: true,
            title: 'Regional Administrators',
            placement: 'bottom',
            trigger: 'hover',
            content: () => {
                let div_id = "tmp-id-" + $.now(); //: thanks to https://stackoverflow.com/a/14560039
                let _content = `<div id="${div_id}"><span class="text-muted"><i class="fa fa-refresh fa-lg fa-spin"></i> Retrieving list of Administrators...</span></div>`;

                // console.info('setupRegionalAdminPopover', { this: this, showCount: showCount, div_id: div_id, _content: _content, divs: $('#' + div_id).length, link: link, linkData: link.data(), linkDataPopoverInstance: link.data('bs.popover') });
                
                this.retrieveRegionalAdministrators((err, data) => {
                    if (!err && data) {
                        var $table = $('<table class="table-striped midi_common_popover_table" style="margin: 0;"></table>');
                        var $tbody = $('<tbody></tbody>').appendTo($table);

                        data.Regions.forEach(region => {
                            var $tr = $('<tr></tr>');
                            $('<td>').text(region.RegionLabel).appendTo($tr);
                            $('<td>').addClass('midi_common_link').html(region.Administrators.join('<br>')).appendTo($tr);

                            $tr.appendTo($tbody);
                        });

                        _content = $('<div>').append($table).html();
                        $('#' + div_id).empty().append($table);
                    } else {
                        $('#' + div_id).empty().append('Error while retrieving list of Regional Administrators.');
                        console.warn('Error while retrieving list of Regional Administrators', { err: err, data: data });
                    }
                });
                
                showCount++;
                return _content;
            }
        });

        return link;
    }

    public getTimeZoneString(): string {
        switch (this.displayTimeType) {
            case DisplayTimeType.UTC:
                return DisplayTimeType.UTC;
            case DisplayTimeType.PcTime:
                return moment(moment.utc()).tz(moment.tz.guess()).format("z").toString();
            case DisplayTimeType.StationRegionTime:
                return moment(moment.utc()).tz(this.selectedRegion.TimeZone).format("z").toString();
            default:
        }
    }

    public getTimeZoneStringFormat(format: string = 'ZZ'): string {
        switch (this.displayTimeType) {
            case DisplayTimeType.UTC:
                return moment(moment.utc()).tz("UTC").format(format).toString();
            case DisplayTimeType.PcTime:
                return moment(moment.utc()).tz(moment.tz.guess()).format(format).toString();
            case DisplayTimeType.StationRegionTime:
                return moment(moment.utc()).tz(this.selectedRegion.TimeZone).format(format).toString();
            default:
        }
    }

    public getTimeZoneName(): string {
        switch (this.displayTimeType) {
            case DisplayTimeType.UTC:
                return "UTC";
            case DisplayTimeType.PcTime:
                return moment.tz.guess();
            case DisplayTimeType.StationRegionTime:
                return this.selectedRegion.TimeZone;
            default:
        }
    }

    public getTimeZoneUtcOffset(): number {
        switch (this.displayTimeType) {
            case DisplayTimeType.UTC:
                return moment(moment.utc()).tz("UTC").utcOffset();
            case DisplayTimeType.PcTime:
                return moment(moment.utc()).tz(moment.tz.guess()).utcOffset();
            case DisplayTimeType.StationRegionTime:
                return moment(moment.utc()).tz(this.selectedRegion.TimeZone).utcOffset();
            default:
        }
    }

    /**
     * A helper function to get appropriately format timezone data for a given timezone ID and its corresponding DisplayTimeType.
     */
    public getTimeZoneData(tzName: string, displayTimeTypeId: string): ITimeZoneData {
        let offsetMinutes: number = moment(moment.utc()).tz(tzName).utcOffset();
        let offsetString: string = moment(moment.utc()).tz(tzName).format('ZZ').toString();
        let timezoneCode: string = moment(moment.utc()).tz(tzName).format('z').toString();
        let label: string = `${timezoneCode} ${offsetString} (${displayTimeTypeId})`;
        if (offsetMinutes == 0 || displayTimeTypeId == DisplayTimeType.UTC) {
            label = `${displayTimeTypeId} (${offsetString})`;
        }

        return {
            timeZoneName: tzName,
            timeZoneCode: timezoneCode,
            offsetMinutes: offsetMinutes,
            offsetString: offsetString,
            label: label,
            displayTimeType: displayTimeTypeId
        };
    }

    /**
     * A helper function to get a list of possible timezones for use in user options and plot/data downloads..
     */
    public getAllAvailableTimeZones(): ITimeZoneData[] {
        let res: ITimeZoneData[] = [];

        res.push(this.getTimeZoneData(DisplayTimeType.UTC, DisplayTimeType.UTC));
        res.push(this.getTimeZoneData(moment.tz.guess(), DisplayTimeType.PcTime));
        res.push(this.getTimeZoneData(this.selectedRegion.TimeZone, DisplayTimeType.StationRegionTime));

        return res;
    }

    public getDisplayTime(timestamp: number, timeZone: string): string {
        switch (this.displayTimeType) {
            case DisplayTimeType.UTC:
                return moment.utc(timestamp).format("YYYY-MM-DD HH:mm").toString() + ' UTC';
                break;
            case DisplayTimeType.PcTime:
                var t = moment.utc(timestamp).tz(moment.tz.guess());
                return t.format("YYYY-MM-DD HH:mm") + ' ' + t.format('z');
                break;
            case DisplayTimeType.StationRegionTime:
                var t = moment.utc(timestamp).tz(timeZone);
                return t.format("YYYY-MM-DD HH:mm") + ' ' + t.format('z');
                break;
            default:
        }
    }

    public tryLogin(email?: string, password?: string): void {
        this.currentLoginPage.setLoggingInInProgressState(true);

        if (email && password) {
            login(email, password,(err: RESTError) => {
                if (err) {
                    if (typeof err.Message !== 'undefined') {
                        this.currentLoginPage.setError(err.Message);
                    }
                    else {
                        this.currentLoginPage.setError('Unknown error occurred');
                    }
                    this.currentLoginPage.setLoggingInInProgressState(false);
                } else {
                    this.tryLogin();
                }
            });
        } else {
            getCurrentUser((err: RESTError, data: UserAccount) => {
                if (err) {
                    this.currentLoginPage.setError(err.Message);
                    this.currentLoginPage.setLoggingInInProgressState(false);
                } else {                       
                    this.currentUser = data;
                    GetPermissionGroupsForUser(this.currentUser.Id, (pgErr: RESTError, pGroups: GroupPermission[]) => {
                        if (pgErr) {
                            this.currentLoginPage.setError(err.Message);
                            this.currentLoginPage.setLoggingInInProgressState(false);
                        } else {
                            this.currentUserGroupPermissions = pGroups;
                            this.staticDataManager = new StaticDataManager();
                            this.staticDataManager.getStaticData((err: any) => {
                                if (err) {
                                    this.currentLoginPage.setError('Error getting Static Data: ' + err);
                                    this.currentLoginPage.setLoggingInInProgressState(false);

                                    return;
                                }

                                this.currentLoginPage.setLoggingInInProgressState(false);
                                this.renderAfterLogin();
                            });
                        }
                    });                       
                }
            });
        }
    }

    private currentLoginPage: LoginPage = null;

    public currentUser: UserAccount;
    public currentUserGroupPermissions: GroupPermission[];
    public liveDataManager: LiveDataManager = new LiveDataManager();
    public GOMAveragesManager: GOMAveragesManager = new GOMAveragesManager();
    public hashData: IHashData;

    public renderAfterLogin(): void {

        this.buildUserNavMenu();
        this.buildRegionSelector();
        //this.buildWarningRulesSelector();

        this.liveDataManager.start();

        this.GOMAveragesManager.start();

        this.currentLoginPage.cleanUp();

        if (this.checkPointerEventsEnabled()) {
            this.dayNightModeDiv = $('<div class="nightmode-box"></div>').appendTo('body');
        }
        this.navBar.navBar.appendTo('body');

        this.hashChange();

        $(window).on('hashchange', () => {
            this.hashChange();
        });

        if ($.isEmptyObject(this.staticDataManager.Schema.RegionSet.Regions)) {
            console.warn('MainSite.renderAfterLogin() - no Regions available!');

            let $dialogContentWrap = $('<div>');
            let $dialogContent = $('<div>').appendTo($dialogContentWrap);
            $dialogContent.addClass('alert alert-danger').css('margin', 0);

            $('<p></p>').appendTo($dialogContent)
                .append($('<span>Your Account on this site does not seem to have any Permissions set or access to any Regions. Please contact your </span>')
                    .append('<span class="regionalAdminLink--placeholder"><strong><u>Regional Administrator</u></strong></span>')
                    .append('<span> to request access.</span>'));

            let dialog = new SimpleDialog('No Regions or Permissions for this Account', $dialogContentWrap.html(), true);
            dialog.getModal().on('shown.bs.modal', () => {
                let regionalAdminLink = this.setupRegionalAdminPopover($('<strong><u>Regional Administrator</u></strong>').css("cursor", "pointer"));
                dialog.getModal().find('.regionalAdminLink--placeholder').empty().append(regionalAdminLink);
            });
            dialog.show();
        }

            /*try {
                if (("NorthSea_Gannet" in this.staticDataManager.Schema.ParameterSchema.Stations)
                    || ("NorthSea_Shearwater" in this.staticDataManager.Schema.ParameterSchema.Stations)
                    || ("NorthSea_Nelson" in this.staticDataManager.Schema.ParameterSchema.Stations)
                    || ("NorthSea_HaeweneBrim" in this.staticDataManager.Schema.ParameterSchema.Stations)
                    || ("NorthSea_Penguins" in this.staticDataManager.Schema.ParameterSchema.Stations)) {
                        
                    new SimpleDialog('Adura assets are leaving METNET Global',
                        '<p>Please note that real-time data from Gannet, Nelson, Shearwater, Haewene Brim and Penguins will not be available on METNET Global starting from 1 December 2025. All users who require access to this data should migrate to the Elements Online portal. Contact Dmitry Besedin at <a href="mailto:d.besedin@adura.com">d.besedin@adura.com</a> for details.</p>',
                        true).show();
                }
            } catch {}*/
    }
    
    /**
         * Returns to the login screen. It is essential that all pages have cleaned up themselves,
         * which is why this should only be called in handleHashChange().
         */
    public logout(): void {
        this.liveDataManager.stop();
        this.GOMAveragesManager.stop();
        $(window).off('hashchange');
        $.removeCookie('session', { path: '/' });
        window.location.hash = '';

        // Detach the navBar without unbinding events
        this.navBar.navBar.detach();

        MainSite.instance.currentLoginPage = new LoginPage();
        MainSite.instance.currentLoginPage.render();
        this.tryLogin();
    }

    private scroller = function (stations: { stationId: string, params: string[] }[], callback: (stationId: string, param: string) => any, timeout: number) {
        let i = 0;
        let j = 0;

        let caller = () => {
            callback(stations[i].stationId, stations[i].params[j]);
            
            if (j == stations[i].params.length - 1) {
                j = 0;
                if (i == stations.length - 1) {
                    i = 0;
                }
                else {
                    i++;
                }
            }
            else {
                j++;
            }

            setTimeout(caller, timeout);
        };

        caller();
    };

    private hashChange(): void {

        //this.pages.push(
        //    ...(((this.selectedRegion) && (this.selectedRegion.Id == "GOM"))
        //        ? [new GOMTablePage(this)]
        //        : [new TablePage(this)]),
        //)

        var newHashData: IHashData = this.hashDataManager.decode(window.location.hash);
        if (this.hashData) {
            if (this.hashData.Page !== newHashData.Page) {
                // things to do when page changes
                $('.midi_siteObsPage_popup').remove();
            }

            if (this.hashData.Page == newHashData.Page && this.hashData.Page == 'siteObs' && this.hashData.PageSpecificData !== newHashData.PageSpecificData) {
                // things to do when a site obs tab changes
                $('.midi_siteObsPage_popup').remove();
            }
        }

        this.hashData = newHashData;
        if (this.hashData.Page == "scrollingSiteObs") {
            let stationIds;

            if (this.hashData.StationIds) {
                stationIds = this.hashData.StationIds;
            }
            else {
                stationIds = [];
                for (let stationId in this.staticDataManager.Schema.ParameterSchema.Stations) {
                    stationIds.push(stationId);
                }
            }

            let stations: { stationId: string, params: string[] }[] = [];

            for (let i = 0; i < stationIds.length; i++) {
                let station = this.staticDataManager.Schema.ParameterSchema.Stations[stationIds[i]];
                if (!station) {
                    return;
                }

                let station_: { stationId: string, params: string[] } = {
                    stationId: stationIds[i],
                    params: []
                }

                let sensorCount = 0;
                for (let sensorId in station.Sensors) {
                    sensorCount++;
                }

                let gotOverview = false;
                let gotClouds = false;
                let gotWaves = false;
                let gotCurrent = false;
                let gotMotion = false;
                let gotWind = false;

                for (let sensorId in station.Sensors) {
                    if (sensorCount !== 1) {
                        gotOverview = true;
                    }

                    const sensor = station.Sensors[sensorId];
                    for (let paramId in sensor.Parameters) {
                        if (paramId.indexOf('Cloud') != -1 || sensorCount > 1) {
                            gotClouds = true;
                        }

                        if (paramId.indexOf('HsT/') != -1 || paramId.indexOf('Hs/') != -1 || sensorCount > 1) {
                            gotWaves = true;
                        }

                        if (paramId.indexOf('Current') != -1 || sensorCount > 1) {
                            gotCurrent = true;
                        }

                        if (paramId.indexOf('Motion') != -1 || sensorCount > 1) {
                            gotMotion = true;
                        }

                        if (paramId.indexOf('Wind') != -1 || sensorCount > 1) {
                            gotWind = true;
                        }
                    }
                }

                (gotOverview) && station_.params.push("overview");
                (gotClouds) && station_.params.push("clouds");
                (gotWaves) && station_.params.push("waves");
                (gotCurrent) && station_.params.push("current");
                (gotMotion) && station_.params.push("motion");
                (gotWind) && station_.params.push("wind");

                stations.push(station_);
            }

            this.scroller(stations, (stationId, parameterId) => {
                this.changePage('siteObs', {
                    Station: stationId,
                    Tab: parameterId
                })
            }, this.hashData.Interval ? this.hashData.Interval * 1000 : 10000);
        }

        this.selectRegion();
        this.buildWarningRulesSelector();
        this.selectWarningRules();
        this.updateStaticLinks();
        this.buildStationSelector();
        this.selectStation();

        //removes any open modals (such as warning modals) when the hash changes.
        if (this.modal) {
            this.modal.modal('hide');
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
            this.modal.remove();
            this.modal = null;
        }

        this.pages.forEach((page: IPage) => {
            page.handleHashChange(this.hashData);
        });

        if (!this.hashData.Page || this.hashData.Page === 'map' || this.hashData.Page.toLowerCase().includes('table') || this.hashData.Page === 'plot' || this.hashData.Page === "forecastsPDFs") {
            this.regionSelector.show();
        } else {
            this.regionSelector.hide();
        }

        if (this.hashData.Page === 'logout') {
            this.logout();
        }
    }

    public changePage(pageId: string, pageSpecificData: any = null): void {

        var newHashData: IHashData = {
            Page: pageId,
            Region: this.hashData.Region,
            WarningGroup: this.hashData.WarningGroup
        };

        if (pageSpecificData) {
            newHashData.PageSpecificData = pageSpecificData;
        }

        window.location.hash = this.hashDataManager.encode(newHashData);
    }

    private userNavMenu: JQuery = null;
    private dayNightModeDiv: JQuery;

    private buildUserNavMenu(): void {
        if (this.userNavMenu) {
            this.userNavMenu.remove();
            this.userNavMenu = null;
        }

        this.userNavMenu = $('<li class="dropdown"></li>')
            .appendTo(this.navBar.navLinksRight);

        $('<a href="#" title="Open User Menu" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false"><span class="caret"></span></a>')
            .prepend($('<span></span>').text(this.currentUser.Id))
            .appendTo(this.userNavMenu)
            .dropdown();
        
            var dd = $('<ul class="dropdown-menu" role="menu"></ul>')
                .appendTo(this.userNavMenu);

            $('<li><a href="#Page=logout">Log Out</a></li>').appendTo(dd);
            $('<li><a href="#">Change Password</a></li>').click(() => {
                this.changePage('changePassword');
                this.userNavMenu.removeClass('open');
                return false;
            }).appendTo(dd);

            $('<li><a href="#">Support</a></li>').click(() => {
                this.changePage('support');
                this.userNavMenu.removeClass('open');
                return false;
            }).appendTo(dd);

            // local time selector
        var displayTimeSelector = $('<li></li>').appendTo(dd);

        if ($.cookie('displayTimeType') != null) {
            switch ($.cookie('displayTimeType')) {
                case DisplayTimeType.UTC:
                    this.displayTimeType = DisplayTimeType.UTC;
                    break;
                case DisplayTimeType.PcTime:
                    this.displayTimeType = DisplayTimeType.PcTime;
                    break;
                case DisplayTimeType.StationRegionTime:
                    this.displayTimeType = DisplayTimeType.StationRegionTime;
                    break;
                default:
            }               
            }
        else {
            //initial display time type
            this.displayTimeType = DisplayTimeType.UTC;
        }

        $('<a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false"> Display Time: </a>')
            .appendTo(displayTimeSelector);
        var UTCTimeSelector = $('<a href="#" style="margin-left: 20px"> UTC </a>').appendTo(displayTimeSelector).click(() => {
            $.cookie('displayTimeType', DisplayTimeType.UTC, {
                expires: 5 * 365
            });
            location.reload();
        });
        var UTCTimeSelectorUnchecked = $('<i id="midi_common_disply_utc_checkbox_unchecked" class="fa fa-square-o"></i>').prependTo(UTCTimeSelector);
        var UTCTimeSelectorChecked = $('<i id="midi_common_display_utc_checkbox_checked" class="fa fa-check-square-o"></i>').prependTo(UTCTimeSelector);

        var pcTimeSelector = $('<a href="#" style="margin-left: 20px"> PC Time </a>').appendTo(displayTimeSelector).click(() => {
            $.cookie('displayTimeType', DisplayTimeType.PcTime, {
                expires: 5 * 365
            });
            location.reload();
        });
        var pcTimeSelectorUnchecked = $('<i id="midi_common_disply_pc_checkbox_unchecked" class="fa fa-square-o"></i>').prependTo(pcTimeSelector);
        var pcTimeSelectorChecked = $('<i id="midi_common_display_pc_checkbox_checked" class="fa fa-check-square-o"></i>').prependTo(pcTimeSelector);

        var stationTimeSelector = $('<a href="#" style="margin-left: 20px"> Region/Station Time </a>').appendTo(displayTimeSelector).click(() => {
            $.cookie('displayTimeType', DisplayTimeType.StationRegionTime, {
                expires: 5 * 365
            });
            location.reload();
        });
        var stationTimeSelectorUnchecked = $('<i id="midi_common_disply_station_checkbox_unchecked" class="fa fa-square-o"></i>').prependTo(stationTimeSelector);
        var stationTimeSelectorChecked = $('<i id="midi_common_display_station_checkbox_checked" class="fa fa-check-square-o"></i>').prependTo(stationTimeSelector);

        switch (this.displayTimeType) {
            case DisplayTimeType.UTC:
                {
                    UTCTimeSelectorChecked.show();
                    UTCTimeSelectorUnchecked.hide();

                    pcTimeSelectorChecked.hide();
                    pcTimeSelectorUnchecked.show();

                    stationTimeSelectorChecked.hide();
                    stationTimeSelectorUnchecked.show();
                    break;
                }
            case DisplayTimeType.PcTime:
                {
                    UTCTimeSelectorChecked.hide();
                    UTCTimeSelectorUnchecked.show();

                    pcTimeSelectorChecked.show();
                    pcTimeSelectorUnchecked.hide();

                    stationTimeSelectorChecked.hide();
                    stationTimeSelectorUnchecked.show();
                    break;
                }
            case DisplayTimeType.StationRegionTime:
                {
                    UTCTimeSelectorChecked.hide();
                    UTCTimeSelectorUnchecked.show();

                    pcTimeSelectorChecked.hide();
                    pcTimeSelectorUnchecked.show();

                    stationTimeSelectorChecked.show();
                    stationTimeSelectorUnchecked.hide();
                    break;
                }
        }

        // Units Conversion Preference:
        $('<a href="#">Units Conversion:</a>').appendTo($('<li></li>').appendTo(dd)).on('click', (e) => { e.preventDefault(); e.stopPropagation(); });
        let ucOptKey = UnitsConversionPreferenceLocalStorageKey;
        let ucOptVal = MainSite.localStorageGet(ucOptKey, undefined); //: uses the first enum option as a default.
        if (!ucOptVal) {
            const tsOffset = -new Date().getTimezoneOffset();
            console.log(`Detecting default unit conversions using time zone offset: ${tsOffset} minutes`);
            if (tsOffset < 0) {
                ucOptVal = "imperial";
            } else {
                ucOptVal = "default";
            }
        }
        for (const ucmKey in UnitsConversionModes) {
            if (ucmKey == 'METRIC') {
                continue;
            }

            let ucmLbl = UnitsConversionModes[ucmKey];

            $(`<a href="#" style="margin-left: 20px">${ucmLbl}</a>`)
                .prepend(`<i class="fa ${ucOptVal == ucmKey.toLowerCase() ? 'fa-check-square-o' : 'fa-square-o'}"></i> `)
                .appendTo($('<li></li>').appendTo(dd))
                .on('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    MainSite.localStorageSet(ucOptKey, ucmKey.toLowerCase());
                    location.reload();
                });
        }


            // basic view
            var basicViewSelector = $('<li></li>').click(() => {
                if (this.basicViewSelectorBool) {
                    $.cookie('basicViewSelectorBool', 'false', {
                        expires: 5 * 365
                    });
                    location.reload();
                }
                else {
                    $.cookie('basicViewSelectorBool', 'true', {
                        expires: 5 * 365
                    });
                    location.reload();
                }
                return false;
            }).appendTo(dd);


            if ($.cookie('basicViewSelectorBool') != null) {
                if ($.cookie('basicViewSelectorBool') == "true") {
                    this.basicViewSelectorBool = true;
                }
                else {
                    this.basicViewSelectorBool = false;
                }
            }
            else {
                this.basicViewSelectorBool = false;
            }

            var basicViewDropdown = $('<a href="#"> Basic Parameter View </a>').appendTo(basicViewSelector);
            var basicViewCheckboxUnchecked = $('<i id="midi_common_display_basic_view_checkbox_unchecked" class="fa fa-square-o"></i>').prependTo(basicViewDropdown);
            var basicViewCheckboxChecked = $('<i id="midi_common_display_basic_view_checkbox_checked" class="fa fa-check-square-o"></i>').prependTo(basicViewDropdown);

            if (this.basicViewSelectorBool) {
                basicViewCheckboxUnchecked.hide();
                basicViewCheckboxChecked.show();
            }
            else {
                basicViewCheckboxUnchecked.show();
                basicViewCheckboxChecked.hide();
            } 
        
            if (this.checkPointerEventsEnabled()) {
                var dayNightModeDropDown = $('<li></li>').click(() => {
                    if (dayNightText.text() == 'Switch to Night Mode') {
                        dayNightText.text('Switch to Day Mode');
                        this.dayNightModeDiv.addClass('midi_common_night_mode');
                    }
                    else {
                        dayNightText.text('Switch to Night Mode');
                        this.dayNightModeDiv.removeClass('midi_common_night_mode');
                    }
                    return false;
                }).appendTo(dd);
                var dayNightText = $('<a href="#">Switch to Night Mode</a>').appendTo(dayNightModeDropDown);
            }

            if (this.currentUser.Permissions.Administrator == true) {
                $('<li><a href="#">Manage Users</a></li>').click(() => {
                    this.changePage('manageUsers');
                    this.userNavMenu.removeClass('open');
                    return false;
                }).appendTo(dd);

                $('<li><a href="#">Manage Group Permissions</a></li>').click(() => {
                    this.changePage('managePermissionGroups');
                    this.userNavMenu.removeClass('open');
                    return false;
                }).appendTo(dd);
        }

            if (this.currentUser.Permissions.Administrator == true) {
                $('<li><a href="#">User Emails</a></li>').click(() => {
                    this.changePage('emailUsers');
                    this.userNavMenu.removeClass('open');
                    return false;
                }).appendTo(dd);
        }

        if (this.currentUser.Permissions.GlobalAdministrator == true || this.currentUser.Permissions.Administrator == true) {
            $('<li><a href="#">Manage Outage Notifications Recipients</a></li>').click(() => {
                this.changePage('autoNotifications');
                this.userNavMenu.removeClass('open');
                return false;
            }).appendTo(dd);

            $('<li><a href="#">Manage Outage Notifications Thresholds</a></li>').click(() => {
                this.changePage('autoNotificationThresholds');
                this.userNavMenu.removeClass('open');
                return false;
            }).appendTo(dd);
        }

            if (this.currentUser.Permissions.Administrator == true) {
                $('<li><a href="#">Manage Range Alerts</a></li>').click(() => {
                    this.changePage('manageAlerts');
                    this.userNavMenu.removeClass('open');
                    return false;
                }).appendTo(dd);
            }

        if (this.currentUser.Permissions.Administrator == true) {
            $('<li><a href="#">Parameter Groups Settings</a></li>').click(() => {
                this.changePage('manageParameterGroupsSettings');
                this.userNavMenu.removeClass('open');
                return false;
            }).appendTo(dd);
        }
    }

    private selectRegion(): void {

        if (!$.isEmptyObject(this.staticDataManager.Schema.RegionSet.Regions)) {
            //if no region set, check to see if we have a cookie for "selectedRegion" and select that region
            if (!this.hashData.Region || !this.staticDataManager.Schema.RegionSet.Regions[this.hashData.Region]) {
                if ($.cookie("selectedRegion") && $.cookie("selectedRegion") in this.staticDataManager.Schema.RegionSet.Regions) {
                    this.hashData.Region = $.cookie("selectedRegion");
                }
                else {
                    const tsOffset = -new Date().getTimezoneOffset();
                    console.log(`Detecting default region using time zone offset: ${tsOffset} minutes`);

                    if ("GOM" in this.staticDataManager.Schema.RegionSet.Regions && tsOffset < 0) {
                        this.hashData.Region = "GOM";
                    } else if ("Australia" in this.staticDataManager.Schema.RegionSet.Regions && tsOffset >= 7 * 60) {
                        this.hashData.Region = "Australia";
                    } else if ("NorthSea" in this.staticDataManager.Schema.RegionSet.Regions) {
                        //set region to North Sea by default
                        this.hashData.Region = "NorthSea";
                    } else {
                        // set region to the first available
                        for (var regionId in this.staticDataManager.Schema.RegionSet.Regions) {
                            this.hashData.Region = regionId;
                            break;
                        }
                    }
                }
            }

            // we can guarantee we have a valid region by this point
            this.regionSelectorSpan.text(this.staticDataManager.Schema.RegionSet.Regions[this.hashData.Region].Label);
            this.selectedRegion = this.staticDataManager.Schema.RegionSet.Regions[this.hashData.Region];

            // The GOM region has a special table page. 
            // Make sure not to "loose" the page when changing between regions while on the table page.
            if (this.selectedRegion.Id == "GOM" && this.hashData.Page == "table") {
                this.hashData.Page = "GOMTable"
            } else if (this.selectedRegion.Id != "GOM" && this.hashData.Page == "GOMTable") {
                this.hashData.Page = "table"
            }
        }

        // highcharts will use UTC if the cookie is set to use UTC
        // otherwise, highcharts will be using the browser local time
        // getTimezoneOffset looks at the timezone offset of each point to ensure the correct DST handling   
        Highcharts.setOptions({
            global: {
                useUTC: $.cookie('displayTimeType') != DisplayTimeType.PcTime,
                timezone: $.cookie('displayTimeType') == DisplayTimeType.StationRegionTime ? this.selectedRegion.TimeZone : '',
            },
        });                    
    }

    private regionSelector: JQuery = null;
    private regionSelectorSpan: JQuery = null;

    private buildRegionSelector(): void {
        if (this.regionSelector) {
            this.regionSelector.remove();
            this.regionSelector = null;
        }

        this.regionSelector = $('<li class="dropdown"></li>')
            .prependTo(this.navBar.navLinksLeft);

        this.regionSelectorSpan = $('<span></span>').text("Select Region");
        $('<a href="javascript:;" title="Selected Region" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false"><span class="caret"></span></a>')
            .prepend(this.regionSelectorSpan)
            .appendTo(this.regionSelector)
            .dropdown();

        var dd = $('<ul class="dropdown-menu" role="menu"></ul>')
            .appendTo(this.regionSelector);

        var selectedRegion: IRegion;

        var selectedRegionId: string = this.hashDataManager.decode(window.location.hash).Region;
        if (selectedRegionId) {
            selectedRegion = this.staticDataManager.Schema.RegionSet.Regions[selectedRegionId];
        }

        for (var regionId in this.staticDataManager.Schema.RegionSet.Regions) {
            
            ((region: IRegion) => {
                $('<a href="#">' + region.Label + '</a>').click((e: JQueryMouseEventObject) => {
                    this.hashData.Region = region.Id;
                    //create selectedRegion cookie once a region is selected from the drop down. Until a new region is selected, this is the default for the user.
                    $.cookie("selectedRegion", this.hashData.Region, { expires: 3000 });
                    $(e.target).attr('href', this.hashDataManager.encode(this.hashData));
                    this.selectWarningRules();
                    this.refreshWarningRulesSelectorContent();
                    this.updateStaticLinks();
                }).appendTo($('<li></li>').appendTo(dd));
            })(this.staticDataManager.Schema.RegionSet.Regions[regionId]);
        }
    }

    private stationSelector: JQuery = null;
    private selectedStationSpan: JQuery = null;

    private selectStation(): void {

        if (this.hashData.Page !== 'siteObs') {
            this.stationSelector.removeClass('active');
            this.selectedStationSpan.text('Station');
            return;
        }

        // if no station group set, or invalid station, set to the first available
        if (!this.hashData.PageSpecificData || !this.hashData.PageSpecificData.Station || !this.staticDataManager.Schema.ParameterSchema.Stations[this.hashData.PageSpecificData.Station]) {
            for (var stationId in this.staticDataManager.Schema.ParameterSchema.Stations) {
                this.hashData.PageSpecificData = {
                    Station: stationId
                };
                break;
            }
        }

        // we can guarantee we have a valid station id by this point
        var station: Station = this.staticDataManager.Schema.ParameterSchema.Stations[this.hashData.PageSpecificData.Station].Station;

        this.stationSelector.addClass('active');
        this.selectedStationSpan.text(station.Label);
    }

    private buildStationSelector(): void {
        if (this.stationSelector) {
            this.stationSelector.remove();
            this.stationSelector = null;
        }

        this.stationSelector = $('<li class="dropdown"></li>')
            .appendTo(this.navBar.navLinksLeft);

        this.selectedStationSpan = $('<span></span>');

        $('<a href="#" title="Select Station" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false"><span class="caret"></span></a>')
            .prepend(this.selectedStationSpan)
            .appendTo(this.stationSelector)
            .dropdown();

        var dd = $('<ul class="dropdown-menu" style="max-height: 350px; overflow: auto;" role="menu"></ul>')
            .appendTo(this.stationSelector);

        let stationsOrdered: Station[] = [];
        for (var stationId in this.staticDataManager.Schema.ParameterSchema.Stations) {

            var station: Station = this.staticDataManager.Schema.ParameterSchema.Stations[stationId].Station;
            if (station.Region !== this.hashData.Region) continue;

            stationsOrdered.push(station);
        }

        stationsOrdered.sort((a, b) => {
            if (a.RegionOrder < b.RegionOrder) {
                return -1;
            } else if (a.RegionOrder > b.RegionOrder) {
                return 1;
            } else {
                return b.Latitude - a.Latitude;
            }
        });

        stationsOrdered.forEach((station) => {
            $('<a title="Jump to Station Overview" href="javascript:void(0);">' + station.Label + '</a>').click((e: JQueryMouseEventObject) => {
                this.selectedStationSpan.text(station.Label);
                this.changePage('siteObs', {
                    Station: station.Id,
                    Tab: SiteObservations.getLandingPageId(station)
                });
                return true;
            }).appendTo($('<li></li>').appendTo(dd));
        });
    }

    private selectWarningRules(): void {
        if ($.isEmptyObject(this.staticDataManager.Schema.RegionSet.Regions)) {
            this.warningRulesSelectorSpan.text("No Warning Rules");
            console.warn('MainSite.selectWarningRules() - no Regions available!');
            return;
        }

        var allowedGroupIds = this.staticDataManager.Schema.RegionSet.Regions[this.selectedRegion.Id].WarningGroupIds;

        if (allowedGroupIds.length == 0) {
            this.warningRulesSelectorSpan.text("No Warning Rules");
            this.selectedWarningRules = null;
            this.hashData.WarningGroup = null;
            return;
        }

        // if no warning group set, or invalid warning group, set to the first allowed
        if (!this.hashData.WarningGroup || allowedGroupIds.indexOf(this.hashData.WarningGroup) == -1) {
            this.hashData.WarningGroup = allowedGroupIds[0];
        }

        // we can guarantee that hashData contains a valid warning group by this point
        this.warningRulesSelectorSpan.text(this.staticDataManager.Schema.WarningGroupSet.WarningGroups[this.hashData.WarningGroup].Label);
        this.selectedWarningRules = this.staticDataManager.Schema.WarningGroupSet.WarningGroups[this.hashData.WarningGroup];
    }

    private updateStaticLinks(): void {
        this.navBar.navLinksCustom.empty();
        if (this.selectedRegion && this.selectedRegion.Id == "NorthSea"
            && !this.currentUser.Permissions.GlobalAdministrator // Hide static links for global admin to preserve nav bar space
        ) {
            $('<li><a href="https://www.helimet.com" target="_blank"><img class="midi_common_navbar-shell" src="images/oilgasuk.png"/></a></li>')
                .prependTo(this.navBar.navLinksCustom);
            $('<li><a href="https://offshore.meteogroup.com/ocw/" target="_blank"><img class="midi_common_navbar-shell" src="images/meteogroup.png"/></a></li>')
                .prependTo(this.navBar.navLinksCustom);
        }
    }

    private warningRulesSelector: JQuery = null;
    private warningRulesDropdown: JQuery = null;
    private warningRulesSelectorSpan: JQuery = null;

    private buildWarningRulesSelector(): void {
        if (this.warningRulesSelector) {
            this.warningRulesSelector.remove();
            this.warningRulesSelector = null;
        }

        this.warningRulesSelector = $('<li class="dropdown"></li>')
            .prependTo(this.navBar.navLinksRight);

        this.warningRulesSelectorSpan = $('<span></span>').text("Select Rules");
        $('<a href="#" title="Selected Warning Rules" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false"><span class="caret"></span></a>')
            .prepend(this.warningRulesSelectorSpan)
            .appendTo(this.warningRulesSelector)
            .dropdown();

        this.warningRulesDropdown = $('<ul class="dropdown-menu" role="menu"></ul>')
            .appendTo(this.warningRulesSelector);

        var selectedWarningGroup: WarningGroup;

        this.refreshWarningRulesSelectorContent();
    }

    private refreshWarningRulesSelectorContent() {

        this.warningRulesDropdown.empty();

        if ($.isEmptyObject(this.staticDataManager.Schema.RegionSet.Regions)) {
            console.warn('MainSite.refreshWarningRulesSelectorContent() - no Regions available!');
            return;
        }

        this.staticDataManager.Schema.RegionSet.Regions[this.selectedRegion.Id].WarningGroupIds.forEach(warningGroupId => {

            ((warningGroup: WarningGroup) => {
                $('<a title="Select Warning Rule" href="#">' + warningGroup.Label + '</a>').click((e: JQueryMouseEventObject) => {
                    this.hashData.WarningGroup = warningGroup.Id;
                    $(e.target).attr('href', this.hashDataManager.encode(this.hashData));
                }).appendTo(
                    $('<li></li>')
                        .append($('<a class="midi_common_dropdownInfo" title="Show Warning Rule Information"><i class="fa fa-info-circle"></i><span class="sr-only">i</span></a>')
                            .click(() => {
                                this.renderWarningGroupsModal(warningGroup);
                            }))
                        .appendTo(this.warningRulesDropdown));
            })(this.staticDataManager.Schema.WarningGroupSet.WarningGroups[warningGroupId]);
        });
    }

    private renderWarningGroupsModal(warningGroup: WarningGroup): void {

        this.modal = $('<div class="modal fade"></div>').appendTo('body');
        var modalDialog = $('<div class="modal-dialog" ></div>').appendTo(this.modal);
        var modalContent = $('<div class="modal-content"></div>').appendTo(modalDialog);

        var modalHeader = $('<div class="modal-header"></div>').appendTo(modalContent);
        modalHeader.append($('<button type="button" class= "close" data-dismiss="modal">&times;</button>'));
        modalHeader.append($('<h4 class="modal-title">Warning Rules - ' + warningGroup.Label + '</h4>'));

        var modalBody = $('<div class="modal-body"></div>').appendTo(modalContent);

        if (!warningGroup.IsFrontEndWarningRuleSet) {

            // the old-style simple server side warning groups

            modalBody.append($('<p>The table below shows the colour-coding rules which are applied to displayed values, when the <strong>' + warningGroup.Label + '</strong> warning rule set is selected.</p>'));

            var tableBody = $('<tbody></tbody>').appendTo(
                $('<table class="table table-striped midi_common_warning_rules_table"></table>')
                    .appendTo(modalBody)
            );

            for (var parameterGroupId in warningGroup.Rules) {

                var rule: WarningRuleSet = warningGroup.Rules[parameterGroupId];

                var row = $('<tr></tr>').append('<td class="midi_common_warning_rules_title_column">' + parameterGroupId + '</td>');

                if (rule.Lt_HighPriority !== null) {
                    row.append('<td class="midi_siteObsPage_exceeded_threshold_3">&lt; ' + rule.Lt_HighPriority + '</td>');
                }

                if (rule.Lt_MediumPriority !== null) {
                    row.append('<td class="midi_siteObsPage_exceeded_threshold_2">&lt; ' + rule.Lt_MediumPriority + '</td>');
                }

                if (rule.Lt_LowPriority !== null) {
                    row.append('<td class="midi_siteObsPage_exceeded_threshold_1">&lt; ' + rule.Lt_LowPriority + '</td>');
                }


                if (rule.Gt_LowPriority !== null) {
                    row.append('<td class="midi_siteObsPage_exceeded_threshold_1">&gt; ' + rule.Gt_LowPriority + '</td>');
                }

                if (rule.Gt_MediumPriority !== null) {
                    row.append('<td class="midi_siteObsPage_exceeded_threshold_2">&gt; ' + rule.Gt_MediumPriority + '</td>');
                }

                if (rule.Gt_HighPriority !== null) {
                    row.append('<td class="midi_siteObsPage_exceeded_threshold_3">&gt; ' + rule.Gt_HighPriority + '</td>');
                }

                tableBody.append(row);
            }
        }
        // else if (warningGroup.Id in FrontEndWarningRules.map) {
        //     var ruleSet = FrontEndWarningRules.map[warningGroup.Id];

        //     modalBody.append(ruleSet.buildInfo());
        // }
            
        this.modal.modal('show');

    }

    private checkPointerEventsEnabled(): boolean {
        return this.isIE() == 0 || this.isIE() > 10;
    }

    private isIE(): any {
        var myNav = navigator.userAgent.toLowerCase();
        return (myNav.indexOf('msie') != -1) ? parseInt(myNav.split('msie')[1]) : 0;
    }

    public dispatchResize() {
        if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
            var evt = document.createEvent('UIEvents');
            (evt as any).initUIEvent('resize', true, false, window, 0);
            window.dispatchEvent(evt);
        } else {
            window.dispatchEvent(new Event('resize'));
        }
    }


    //: helper functions to get lists of Region/Station/Parameters (initially setup on ManageParameterGroupsSettings.ts, then brought to MainSite to use in ManageAlerts.ts and eventually others if needed)

    public getStationsByRegions(sortAlpha: boolean = false): IStationsByRegion[] {
        const { Regions } = this.staticDataManager.Schema.RegionSet;
        const { Stations } = this.staticDataManager.Schema.ParameterSchema;

        let _list: IStationsByRegion[] = [];

        for (const regionId in Regions) {
            let _region: IStationsByRegion = {
                Region: Regions[regionId],
                Stations: []
            };

            for (let stationId in Stations) {
                const station = Stations[stationId];
                if (station.Station.Region == _region.Region.Id) {
                    _region.Stations.push(station.Station);
                }
            }

            if (sortAlpha) {
                _region.Stations.sort((a, b) => (a.Label > b.Label) ? 1 : -1);
            }

            _list.push(_region);
        }

        if (sortAlpha) {
            _list.sort((a, b) => (a.Region.Label > b.Region.Label) ? 1 : -1);
        }

        return _list;
    }

    public getStationSensors(stationId: string): { [sensorId: string]: ParameterSchemaSensor } {
        let _list: { [sensorId: string]: ParameterSchemaSensor } = {};

        const { Stations } = this.staticDataManager.Schema.ParameterSchema;
        if (stationId in Stations) {
            _list = Stations[stationId].Sensors;
        }

        // TODO: sort alpha?..

        return _list;
    }

    public getStationSensorParameters(stationId: string, sensorId: string): { [parameterId: string]: ParameterInfo } {
        let _list: { [parameterId: string]: ParameterInfo } = {};
        let _sensors: { [sensorId: string]: ParameterSchemaSensor } = {};

        const { Stations } = this.staticDataManager.Schema.ParameterSchema;
        if (stationId in Stations) {
            _sensors = Stations[stationId].Sensors;

            if (sensorId in _sensors) {
                _list = Stations[stationId].Sensors[sensorId].Parameters;
            }
        }

        // TODO: sort alpha?..

        return _list;
    }

    public getStationParameterGroups(stationId: string, sensorId: string): string[] {
        let _list: string[] = [];
        const ldStations: { [stationId: string]: LiveDataSetStation } = this.liveDataManager.latestData.Stations;

        if (stationId in ldStations) {
            const ldStation: LiveDataSetStation = ldStations[stationId];

            for (let groupId in ldStation.GroupValues) {
                let _include: boolean = false;
                const groupValues = ldStation.GroupValues[groupId];
                groupValues.forEach((ldsv: LiveDataSetValue) => {
                    if (ldsv.Sensor == sensorId) {
                        _include = true;
                    }
                });

                if (_include) {
                    _list.push(groupId);
                }
            }
        }

        _list.sort((a, b) => (a > b) ? 1 : -1);

        return _list;
    }


    /**
     * Helper function to set a key/value pair to browser's local storage. This will try using localStorage API before using cookies, to avoid overloading server requests with unecessary cookies data.
     * @param key
     * @param value If this is set to null, the local storage key/value pair will be deleted.
     */
    public static localStorageSet(key: string, value: string): void {
        if (this.localStorageCheckCapability()) {
            if (value === null) {
                localStorage.removeItem(key);
            } else {
                localStorage.setItem(key, value);
            }
        } else {
            if (value === null) {
                $.removeCookie(key);
            } else {
                $.cookie(key, value, { expires: 5 * 365, path: '/' });
            }
        }
    }

    /**
     * Helper function to get a value from a key/value pair stored in browser's local storage (trying to use localStorage API before using cookies).
     * @param key
     * @param defaultValue If key does not exist, then the defaultValue is returned.
     * @param setIfNotExists If set to TRUE and the key does not exist (in either localStorage or cookie), then the defaultValue will be set in local storage via localStorageSet() method.
     */
    public static localStorageGet(key: string, defaultValue: string, setIfNotExists: boolean = false): string {
        if (this.localStorageCheckCapability()) {
            let val: string = localStorage.getItem(key);
            if (val === null) {
                if ($.cookie(key) !== undefined) { //: we have a cookie for this key, so set it to localStorage, and return the cookie
                    val = $.cookie(key);
                    this.localStorageSet(key, val);
                    return val;
                }

                if (setIfNotExists) {
                    this.localStorageSet(key, defaultValue);
                }
                return defaultValue;
            } else {
                return val;
            }
        } else {
            let val: string = $.cookie(key);
            if (val === null || val === undefined) {
                if (setIfNotExists) {
                    this.localStorageSet(key, defaultValue);
                }
                return defaultValue;
            } else {
                return val;
            }
        }
    }

    private static localStorageCheckCapability(): boolean { //: SEE: https://stackoverflow.com/a/16427747/753113
        let test = 'LocalStorageTest';
        try {
            localStorage.setItem(test, test);
            localStorage.removeItem(test);
            return true;
        } catch (e) {
            return false;
        }
    }


    private _pageBlockJquerySelector: string | Window = window; //: NB: this should correspond to one single element, otherwise onBlock option will be executed once for each matching element! (so I've added blocking of the navbar separately!)

    /**
     * UI Page blocking (for AJAX actions... initially setup in Plotting Page, later made available throughout the site for other pages.)
     * @param message
     * @param blockNavBar Should we also block the top navbar? (recommended)
     * @param callback Function to be executed once blocking is complete.
     */
    public pageBlock(message: string = '', blockNavBar: boolean = true, callback?: () => void): void {
        let _msg: string = '';
        let progressBar: string = '<div class="progress" style="margin:0"><div class="progress-bar progress-bar-striped active" style="width: 100%"></div></div>';
        let css: { [key: string]: string } = {
            border: 'none',
            backgroundColor: 'transparent',
            color: '#fff'
        };

        let $msg: JQuery = $('<div>');
        if (message.length > 0) {
            $msg.text(message); //: use this to escape content..
            _msg = progressBar + '<div style="margin-top: 5px;">' + $msg.html() + '</div>';
        } else {
            _msg = progressBar;
        }

        if (blockNavBar) {
            $(".navbar.navbar-fixed-top").block({
                message: '',
                css: css
            });
        }

        $(this._pageBlockJquerySelector).block({
            message: _msg,
            css: css,
            onBlock: () => {
                $('body').css({ overflow: 'hidden' });
                if (typeof (callback) == "function") {
                    callback();
                }
            }
        });
    }

    /**
     * Unblock the UI page.
     */
    public pageUnblock(): void {
        $('body').css({ overflow: '' });
        $(".navbar.navbar-fixed-top").unblock();
        $(this._pageBlockJquerySelector).unblock();
    }


    /**
     * A utility function to help with string escaping to prevent XSS attacks, where we're using $().html() if necessary.
     * @param str
     */
    public static escapeString(str: string): string {
        return str.replace(/(<([^>]+)>)/gi, ""); //: https://css-tricks.com/snippets/javascript/strip-html-tags-in-javascript/ (alternatively, use $(`<div>${str}</div>`).text())
    }

    /**
     * Returns the "fa-" prefixed classname relevant for the provided type (region, station, sensor, parameter..)
     * @param type Should be region, station, sensor, parameter or parametervariant.
     */
    public static getAwesomeIconClass(type: string = "station"): string {
        switch (type.toLowerCase()) {
            case "region":
                return "fa-globe";
            case "station":
                return "fa-map-pin";
            case "sensor":
                return "fa-cog";
            case "parameter":
                return "fa-circle-thin";
            case "parametervariant":
                return "fa-circle";
            default:
                return "fa-question-circle";
        }
    }
}

